import { render } from "./ReportBugView.vue?vue&type=template&id=fb3c4f60"
import script from "./ReportBugView.vue?vue&type=script&lang=js"
export * from "./ReportBugView.vue?vue&type=script&lang=js"

import "./ReportBugView.vue?vue&type=style&index=0&id=fb3c4f60&lang=scss"

import exportComponent from "/opt/build/repo/energy-hub-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__